import { render } from "./BookShelf.vue?vue&type=template&id=0ff56582&scoped=true"
import script from "./BookShelf.vue?vue&type=script&lang=js"
export * from "./BookShelf.vue?vue&type=script&lang=js"

import "./BookShelf.vue?vue&type=style&index=0&id=0ff56582&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff56582"]])

export default __exports__